import React from 'react'

const IconMyContent = (props) => {
  const { color } = props
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <defs>
        <path id='ldzbulyiua' d='M0 0h40.95v39H0z' />
      </defs>
      <g transform='translate(4 5)' fill='none' fillRule='evenodd'>
        <mask id='9m4swddujb' fill='#fff'>
          <use xlinkHref='#ldzbulyiua' />
        </mask>
        <path d='M6 23h17V6H6v17zm18 2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h19z' fill={color} mask='url(#9m4swddujb)' />
        <path d='M38.595 20.654 29 30.249l-1.392 1.392-.608.17-2.511.704.874-3.12L27 27.76l2-2 7.35-7.35a1.22 1.22 0 0 1 1.726 0l.519.519a1.22 1.22 0 0 1 0 1.726zM27 37H2V2h25v22.93l-3.051 3.052a2 2 0 0 0-.512.874l-.874 3.119a2 2 0 0 0 2.466 2.466L27 33.888V37zm13.01-19.486-.519-.52a3.204 3.204 0 0 0-2.278-.942 3.2 3.2 0 0 0-2.277.943L29 22.93V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v37a1 1 0 0 0 1 1h27a1 1 0 0 0 1-1v-4.928c.007-.006.016-.01.023-.017L40.01 22.069a3.226 3.226 0 0 0 0-4.555z' fill={color} mask='url(#9m4swddujb)' />
        <path d='M20 28H6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1' fill={color} mask='url(#9m4swddujb)' />
      </g>
    </svg>
  )
}

export default IconMyContent
